import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSignOutAlt, FaBars } from "react-icons/fa";
import "./Navbar.css";
import Image from "../assets/KALE-PLATFORM-LOGO-C2.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';


const NavBar = () => {
  const auth = useSelector((state) => state.auth.auth);
  console.log(auth,"authhh");
  

    const isAdmin = auth?.user?.is_admin;


  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const logOutFunck = () => {
    localStorage.clear();
    window.location = "/auth";
  };

  const handleNavigate = (path) => {
    setMenuOpen(false); // Menü kapansın mobilde
    navigate(path);
  };

  return (
    <div className="navbar-container">
      <div className="navbar-inner d-flex align-items-center justify-content-between w-100">
        {/* Logo */}
        <div className="d-flex align-items-center gap-2">
          <img src={Image} alt="Logo" height="40" />
        </div>

        {/* Hamburger Button */}
        <button
          className="d-md-none btn btn-link text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <FaBars size={24} />
        </button>

        {/* Menü (md ve üstü ekranlarda daima açık) */}
        <div className={`menu-items ${menuOpen ? "menu-open" : ""}`}>
        <div onClick={() => handleNavigate("/home")} className="nav-item">
  Ana Sayfa
</div>
<div onClick={() => handleNavigate("/home/teklifformuolustur")} className="nav-item">
  Teklif Formu Oluştur
</div>
<div onClick={() => handleNavigate("/home/kiradakiurunler")} className="nav-item">
  Kiralamalar
</div>
<div onClick={() => handleNavigate("/home/firmalar")} className="nav-item">
  Firma Bilgileri
</div>
<div onClick={() => handleNavigate("/home/urunler")} className="nav-item">
  Ürün Bilgileri
</div>
{isAdmin&&(
  <div onClick={() => handleNavigate("/home/onaybekleyenler")} className="nav-item">
  Onay Bekleyen Kullanıcılar
</div>
  
)}


        </div>

        {/* Logout */}
        <div
          onClick={logOutFunck}
          className="logout-btn text-danger d-flex align-items-center"
        >
          <FaSignOutAlt size={20} className="me-2" />
          <span>Çıkış</span>
        </div>
      </div>
    </div>
  );
};

export default NavBar;